import { BaseModel } from '@/api/base-model'
import { Company } from '@/api/model/company'

export class GamificationSettings extends BaseModel<GamificationSettings> {
    protected collectionName = 'gamification_settings'

    constructor(
        public id: string,
        public enabled: boolean,
        public resultsPerEmail: boolean,
        public progressPerEmail: boolean,
        public activatedBadges: string[],
        public company: Company|string,
    ) { super(id) }

    static fromData(data: any): GamificationSettings {
        if (data === null || typeof data === 'string' || data instanceof GamificationSettings) {
            return data
        }

        return new GamificationSettings(
            data.id,
            data.enabled || false,
            data.resultsPerEmail || false,
            data.progressPerEmail || false,
            data.activatedBadges || [],
            data.company ? Company.fromData(data.company) : null,
        )
    }

    static new(id: string): GamificationSettings {
        return new GamificationSettings(
            id,
            false,
            false,
            false,
            [],
            id,
        )
    }
}
